/* eslint-disable prefer-const */
import React, { useRef } from 'react';
import MUIDialog, { DialogProps as MUIDialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Toolbar from '@mui/material/Toolbar';
import AppBar from '@mui/material/AppBar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Close as CloseIcon } from '@mui/icons-material';
import ElevationScroll from '../ElevationScroll';
import { useTranslation } from 'react-i18next';
import Button from '../../Button';

export interface DialogProps extends MUIDialogProps {
  open: boolean;
  title?: string;

  onClose?: () => unknown;
  onSave?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => unknown;
  disableSave?: boolean;
  buttonActions?: JSX.Element;
  children: React.ReactNode;
}

export function Dialog(props: DialogProps) {
  let {
    title,
    onClose,
    onSave,
    buttonActions,
    disableSave,
    children,
    ...dialogProps
  } = props;
  const { t } = useTranslation();
  if (!buttonActions)
    buttonActions = (
      <>
        <Button type="button" variant="text" onClick={onClose}>
          {t('button.cancel')}
        </Button>
        <Button
          type="submit"
          variant="contained"
          onClick={onSave}
          disabled={disableSave}
        >
          {t('button.save')}
        </Button>
      </>
    );

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  let contentRef = useRef(null);

  return (
    <MUIDialog
      onClose={onClose}
      fullScreen={fullScreen}
      {...dialogProps}
      aria-labelledby="form-dialog-title"
    >
      <ElevationScroll target={contentRef.current}>
        <AppBar position="static" variant="elevation">
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>
              {title}
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              aria-label="close"
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
      <DialogContent ref={contentRef}>{children}</DialogContent>
      <DialogActions>{buttonActions}</DialogActions>
    </MUIDialog>
  );
}

export default Dialog;
